import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context";
import App from "./App";
import store from "./redux/store";
import process from "process";

import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import "./index.css";
import "./i18n";

// Import the process-nextick-args polyfill
// import 'process-nextick-args';

if (!window.process) {
  window.process = process; // Assign the imported process object
}

// Global error handler for Bootstrap component errors and image loading errors
window.addEventListener(
  "error",
  (e) => {
    if (
      e.message &&
      e.message.includes("Cannot read properties of undefined")
    ) {
      // Suppress Bootstrap modal-related undefined property errors
      if (
        e.filename &&
        (e.filename.includes("modal.js") ||
          e.filename.includes("base-component.js"))
      ) {
        e.preventDefault();
        return false;
      }
    }

    // Suppress image loading errors (400, 404, etc.)
    if (e.target && e.target.tagName === "IMG") {
      e.preventDefault();
      return false;
    }
  },
  true
);

// Additional safety check for Bootstrap modal initialization
document.addEventListener("DOMContentLoaded", function () {
  // Override Bootstrap modal initialization to add safety checks
  if (window.bootstrap && window.bootstrap.Modal) {
    const originalGetOrCreateInstance =
      window.bootstrap.Modal.getOrCreateInstance;
    window.bootstrap.Modal.getOrCreateInstance = function (element, config) {
      try {
        if (element && element.classList) {
          return originalGetOrCreateInstance.call(this, element, config);
        }
      } catch (error) {
        // Silently handle modal initialization errors
        return null;
      }
    };
  }

  // Override fetch to handle image loading errors silently
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    return originalFetch.apply(this, args).catch((error) => {
      // If it's an image request that failed, return a rejected promise silently
      if (
        args[0] &&
        typeof args[0] === "string" &&
        (args[0].includes("imagekit.io") ||
          args[0].includes(".jpg") ||
          args[0].includes(".png"))
      ) {
        return Promise.reject(new Error("Image load failed"));
      }
      // For other requests, let them fail normally
      return Promise.reject(error);
    });
  };
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
